import React from 'react';
import { Modal } from '@tradingblock/components';
import { ClearerType, ApplicationFormSection } from '../../../../types';

interface ClearerTypeLearnMoreModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  clearer: ClearerType | null;
  getText: ApplicationFormSection['getText'];
}

export const ClearerTypeLearnMoreModal: React.FC<ClearerTypeLearnMoreModalProps> = ({
  show,
  setShow,
  clearer,
  getText,
}) => {
  const isRQD = clearer === ClearerType.RQD;
  const isApex = clearer === ClearerType.Apex;

  return (
    <Modal show={show} setShow={setShow} size="lg" className="service-level-modal">
      <div className="modal-header">
        <h5 className="modal-title">
          {getText('defaults.clearerType.title')} –{' '}
          {isRQD ? getText('defaults.clearerType.rqd') : getText('defaults.clearerType.apex')}
        </h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={() => setShow(false)} />
      </div>
      <div className="modal-body">
        {/* Use existing i18n copy per clearer */}
        <div className="mb-3">
          <div className="fw-bold">{getText('defaults.clearerType.best.title')}</div>
          <div>{isRQD ? getText('defaults.clearerType.best.rqd') : getText('defaults.clearerType.best.apex')}</div>
        </div>

        <div className="mb-3">
          <div className="fw-bold">{getText('defaults.clearerType.assetTypes.title')}</div>
          <div>
            {isRQD ? getText('defaults.clearerType.assetTypes.rqd') : getText('defaults.clearerType.assetTypes.apex')}
            {isApex ? (
              <span className="d-block text-muted small">
                ({getText('defaults.clearerType.assetTypes.apexSubText')})
              </span>
            ) : null}
          </div>
        </div>

        <div className="mb-3">
          <div className="fw-bold">{getText('defaults.clearerType.stockETFCommission.title')}</div>
          <div>
            {isRQD ? (
              getText('defaults.clearerType.stockETFCommission.rqd')
            ) : (
              <>
                <div>{getText('defaults.clearerType.stockETFCommission.apex.1')}</div>
                <div>{getText('defaults.clearerType.stockETFCommission.apex.2')}</div>
              </>
            )}
          </div>
        </div>

        <div className="mb-3">
          <div className="fw-bold">{getText('defaults.clearerType.optionCommission.title')}</div>
          <div>
            {isRQD ? (
              getText('defaults.clearerType.optionCommission.rqd')
            ) : (
              <>
                <div>{getText('defaults.clearerType.optionCommission.apex.1')}</div>
                <div>{getText('defaults.clearerType.optionCommission.apex.2')}</div>
              </>
            )}
          </div>
        </div>

        <div className="mb-3">
          <div className="fw-bold">{getText('defaults.clearerType.brokerAssisted.title')}</div>
          <div>
            {isRQD
              ? getText('defaults.clearerType.brokerAssisted.rqd')
              : getText('defaults.clearerType.brokerAssisted.apex')}
          </div>
        </div>

        <div className="mb-3">
          <div className="fw-bold">{getText('defaults.clearerType.cashieringMethods.title')}</div>
          <div>
            {isRQD
              ? getText('defaults.clearerType.cashieringMethods.rqd')
              : getText('defaults.clearerType.cashieringMethods.apex')}
          </div>
        </div>

        <div className="mb-3">
          <div className="fw-bold">{getText('defaults.clearerType.accountTypes.title')}</div>
          <div>
            {isRQD
              ? getText('defaults.clearerType.accountTypes.rqd')
              : getText('defaults.clearerType.accountTypes.apex')}
          </div>
        </div>

        <div className="text-muted small fst-italic fw-bold">{getText('defaults.clearerType.disclaimer')}</div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>
          Close
        </button>
      </div>
    </Modal>
  );
};
